module.exports = __webpack_public_path__ + "media/svg/motivations-selected-9cdd9fcf.svg";